<!--
 * @Author: Shber
 * @Date: 2023-04-20 10:41:52
 * @LastEditors: Shber
 * @LastEditTime: 2023-04-27 17:19:48
 * @Description:
-->
<template>
  <div class="menu_swiper">
    <gc-loading :is-show="loading" />

    <div class="icon_back" @click="goBack" />
    <van-swipe :initial-swipe="swiperIndex" style="height: 100vh;" vertical :loop="false" :show-indicators="false" @change="swiperChange">
      <van-swipe-item v-for="(item,i) in state.dataList" :key="item.food_id">
        <div class="swiper_item">
          <van-swipe
            style="height: 80vh;"
            :loop="false"
            :initial-swipe="item.index"
            :show-indicators="false"
            @change="itemChage(i, $event, item)"
          >
            <van-swipe-item v-for="img in item.food.pic_arr" :key="img">
              <div class="img_item">
                <van-image width="100vw" height="80vh" fit="scale-down" :src="img" />
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="swiper_text">
            <h4 class="fw_bold">{{ item.food.food_name }}</h4>
            <!-- <p ref="textBox" :class="{'text_overflow3':item.textHide, 'pack_text':true, 'is_full':!item.textFull} ">
              <span v-show="isShow(item, i) && item.textHide" class="pack_down" title="展开" @click="item.textHide = false"> {{ $t('articles.text9') }}</span>
              <span :ref="`item_${i}`">{{ item.food.jianjie1 }}</span>
            </p>
            <span v-show="!item.textHide" class="pack_up" title="收起" @click="item.textHide = true"> {{ $t('articles.text10') }}</span> -->
            <div class="text_content">
              <div class="wrapper">
                <div ref="textBox" :class="{'text':true, 'is_full': !item.textHide}">
                  <template v-if="item.textFull">
                    <label v-show="isShow(item, i) && item.textHide" class="pack_down" title="展开" @click="setTextHide(item)"> {{ $t('articles.text9') }}</label>
                  </template>
                  <span ref="textLine" class="text_line">
                    {{ item.food.jianjie1 }}
                  </span>
                </div>
              </div>
            </div>
            <div class="tag_content">
              <span v-show="!item.textHide" class="pack_up" title="收起" @click="item.textHide = true"> {{ $t('articles.text10') }}</span>
              <ul v-if="item.food.label.length" class="tag_list">
                <li v-for="(label,l) in item.food.label" :key="l"># {{ label }}</li>
              </ul>
            </div>

            <div style="clear:both;" />
            <div v-show="item.food.pic_arr.length > 1" class="indicators">
              <div v-for="(step,s) in item.food.pic_arr.length" :key="step" :class="{'step':true, 'active': s === item.index}" />
            </div>
            <div class="button_group">
              <!-- <template v-if="item.custom == 0"> -->
              <div>
                <a v-if="item.is_view === 1" class="btn btn2" title="查看完整作品" :href="goFoodview(item)">
                  {{ $t('articles.text4') }}
                </a>
                <template v-else>
                  <span v-if="item.apply_status == 1" class="btn btn1" title="多少人想要">{{ $t('articles.text5[0]') }} {{ item.apply_num }} {{ $t('articles.text5[1]') }} <i class="icon_tip" @click="clickTip" /></span>
                  <span v-else class="btn" title="我想要完整作品" @click="applyView(item, 2)">{{ $t('articles.text6') }} <i class="icon_tip" @click.stop="clickTip" /></span>
                </template>
              </div>
              <div v-if="item.custom == 0" class="group_right">
                <span v-if="item.food.ps == 1" class="icon_like icon_like_active" @click="praiseAdd(item)" />
                <span v-else class="icon_like" @click="praiseAdd(item)" />

                <span v-if="item.food.like_status == 1" class="icon_star icon_star_active" @click="likeDel(item)" />
                <span v-else class="icon_star" @click="likeAdd(item)" />
              </div>
            </div>
            <div class="animation">
              <div v-if="i == state.dataList.length -1" :class="{'finish':inFinish}" title="最后一个作品">{{ $t('articles.text7') }}</div>
              <div v-else class="check_up" />
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <van-popup :show="isTipshow">
      <div class="popup_content">
        <p>{{ $t('articles.text8') }}</p>
        <span class="gc_button" title="我知道了" @click="isTipshow = false">{{ $t('auth.nameAuth.isKnow') }}</span>
      </div>
    </van-popup>
  </div>

</template>

<script setup>
import { reactive, ref, onBeforeMount } from 'vue'
import { useRouter } from 'vue-router'

import { Toast, Image as VanImage, Popup as vanPopup, Swipe as vanSwipe, SwipeItem as vanSwipeItem } from 'vant'
import '@/style/scss/articles/temp3.scss'
import { get, post } from '@/api/ajax.js'
import { ajaxHttp } from '@/api/api.js'
import config from '@/config/config.js'
import { checkloginCallback } from '@/utils'
import utils from '@/utils/utils'
import gcLoading from '@/components/gc-loading'

const router = useRouter()
const query = ref(router.currentRoute.value.query) // 页面id
// const itemIndex = ref(0)
const inFinish = ref(false)
const isTipshow = ref(false)
const loading = ref(true)
const textBox = ref(null)
const textLine = ref(null)
const state = reactive({ dataList: [] })
const noChage = ref(false) // 做一个标识，只有reload的时候触发
const swiperIndex = ref(query.value.index * 1 ? query.value.index * 1 - 1 : 0) // 控制上下滑动swiper展示第几个

onBeforeMount(() => {
  utils.hiddenNavi()
  utils.hideShare() // 隐藏分享按钮
})

const goBack = () => { // 返回
  window.history.back()
  utils.closeWindow()
}

const setTextHide = (_item) => {
  noChage.value = true
  _item.textHide = false
}
const isShow = async(_item, _i) => { // 计算文字展开按钮是否展示
  if (noChage.value) { return false }
  if (!textBox.value) { return false }
  const parentHeight = textBox.value[_i].offsetHeight // 父级元素
  const childHeight = textLine.value[_i].offsetHeight // 子元素
  _item.textFull = childHeight > (parentHeight + 5)
  console.log('isShow-change', _item)
  return true
}

const swiperChange = (e) => { // 上下滑动 swiper-changge
  inFinish.value = e + 1 === state.dataList.length
  state.dataList[e].index = 0 // 重制左右滑动的状态
  state.dataList[e].textHide = true // 重制文字展开状态
  viewLog(state.dataList[e])
}
const itemChage = (_i, e, _item) => { // 左右滑动 swpier-change
  setTimeout(() => { // 延迟赋值，因为有过渡动画
    _item.index = e
  }, 300)
}

const praiseAdd = async(_item) => { // 点赞
  checkloginCallback(
    function() {
      ajaxHttp.praise({ id: _item.food.id, type: 1 }).then(res => {
        if (res.code === 1) {
          _item.food.ps = 1
        } else { Toast(res.message) }
      })
    }
  )
}
const likeAdd = async(_item) => { // 收藏
  checkloginCallback(
    function() {
      ajaxHttp.likeAdd({ id: _item.food.id,
        type: 1,
        test: '7',
        plant: '2' }).then(res => {
        if (res.code === 1) {
          _item.food.like_status = 1
        } else { Toast(res.message) }
      })
    }
  )
}
const likeDel = async(_item) => {
  checkloginCallback(
    function() {
      ajaxHttp.likeDel({ id: _item.food.id,
        type: 1,
        test: '7',
        plant: '2' }).then(res => {
        if (res.code === 1) {
          _item.food.like_status = 0
        } else { Toast(res.message) }
      })
    }
  )
}
const goFoodview = (_item) => { // 查看作品详情
  return `${config.webapplink}/foodview?id=${_item.food.id}`
}
const applyView = (_item, type = 1) => { // 申请查看完整作品
  const data = {
    news_id: query.value.id,
    food_id: _item.food.id,
    type: type,
    custom: _item.custom
  }
  checkloginCallback(
    function() {
      post('/articles/news_menu_viewlog', data).then(res => {
        if (type === 2) {
          _item.apply_status = 1
          _item.apply_num += 1
        } else { Toast(res.message) }
      })
    }
  )
}
const viewLog = async(_item, type = 1) => { // 浏览记录
  const data = {
    news_id: query.value.id,
    food_id: _item.food.id,
    type: type,
    custom: _item.custom
  }
  const res = await post('/articles/news_menu_viewlog', data)
  if (res.code === 1) {
    console.log('浏览记录成功')
  } else { Toast(res.message) }
}
const getDataList = async() => { // 获取列表数据
  loading.value = true
  const res = await get('/articles/food_detail', { id: query.value.id })
  if (res.code === 1) {
    state.dataList = res.data
    state.dataList.forEach((res, i) => {
      res.index = 0
      res.textHide = true
      res.textFull = true
    })
    viewLog(res.data[0])
    inFinish.value = query.value.index * 1 === state.dataList.length // 首次进来判断时候在最后一个作品
  } else { Toast(res.message) }
  loading.value = false
}
getDataList()

const clickTip = () => { // 点击问号❓弹出提示
  isTipshow.value = true
}
</script>
